class Tracking {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-tracking'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.allowedEventTypes = ['click']; // Define which event types are allowed for tracking

        // Elements
        this.$tracking = element;

        // Options
        this.data = this.$tracking.dataset.tracking;
        this.parsedData = null;
        this.eventType = null;
    }

    initialize () {
        // Parse data if available
        if (this.data !== '') {
            this.parseData();
        }
    }

    parseData () {
        try {
            // Parse JSON data and configure event type
            this.parsedData = JSON.parse(this.data);

            if (Object.prototype.hasOwnProperty.call(this.parsedData, 'type')) {
                this.eventType = this.parsedData.type;
                delete this.parsedData.type;

                if (this.allowedEventTypes.indexOf(this.eventType) !== -1) {
                    this.setEvents();
                }
            }
        } catch (e) {
            // Handle JSON parsing errors
            console.error('Parsing error:', e);
        }
    }

    setEvents () {
        // Attach event listener based on event type
        this.$tracking.addEventListener(this.eventType, (e) => {
            this.sendData();
        });
    }

    sendData () {
        // Push tracking data to dataLayer for analytics
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gaEvent',
            ...this.parsedData
        });
    }
}

export { Tracking };
